import { GetterTree } from 'vuex';

export const getters = {};
